module.exports = "https://cdn.redage.net/src/views/games/other/images/maps/mafia2.png";